module.exports = __webpack_public_path__ + "static/media/TP7.c9610b62.jpg";